"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "@/components/ui/CardImage";
type AstrologyHeaderData = {
  imageSrc: string;
  imageAlt: string;
  title: string;
  dateRange: string;
};
const ASTROLOGY_HEADER_DATA: AstrologyHeaderData = {
  imageSrc: "https://media.dinamani.com/dinamani/2026-02-27/a2m82fgm/மேஷம்.png",
  imageAlt: "Mesham Logo",
  title: "மேஷ ராசகம்",
  dateRange: "March 21 - April 19"
};
export default function AstrologyHeader() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-14 h-14"><Image src={ASTROLOGY_HEADER_DATA.imageSrc} alt={ASTROLOGY_HEADER_DATA.imageAlt} width={68} height={68} className="w-68 h-14 object-contain rounded-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-full bg-[#012061] text-white px-6 py-4 flex items-center justify-between"><div className="flex items-center gap-4">{t0}<div className="flex flex-col"><h2 className="text-24-tamil-700 text-FFFFFF">{ASTROLOGY_HEADER_DATA.title}</h2><p className="text-14-tamil-500 text-DCDCDC">{ASTROLOGY_HEADER_DATA.dateRange}</p></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}